import { NewsItem } from '@/app/libs/match/types'
import calendarImage from '@/assets/images/calendar.svg'
import CustomLink from '@/shared/components/customLink'
import MyImage from '@/shared/components/myImage'
import { ClockIcon } from '@/shared/Icons'
import { convertDt24h, getImgURL } from '@/shared/utils'

export function MatchCard({ data }: { data: NewsItem }) {
  return (
    <div className="w-full mx-auto gap-3 text-white overflow-hidden flex flex-col md:flex-row relative">
      {data.oSeo.sSlug && data.oSeo.eStatus === 'a' ? (
        <CustomLink
          className="absolute inset-0 h-full w-full z-10 opacity-0"
          href={`/${data.oSeo.sSlug}`}
        >
          {data._id}
        </CustomLink>
      ) : null}
      <div className="w-full md:w-[296px] h-[175px] md:h-auto relative">
        <MyImage
          src={getImgURL(data.oImg.sUrl)}
          alt={data?.oImg?.sText}
          className="rounded-xl md:rounded-xl w-full object-cover h-[175px]"
          width={296}
          height={200}
        />
      </div>

      <div className="md:w-full flex flex-col justify-between">
        <div>
          <h2 className="text-xl font-bold leading-snug mb-2 line-clamp-2 text-textOffWhite">
            {data?.sTitle}
          </h2>
          <p className="text-base text-textDselected leading-5 mb-4 line-clamp-2">
            {data?.sSubtitle}
          </p>
        </div>

        <div className="flex items-center text-xs text-zinc-500 gap-4">
          {data.dPublishDate || data.dPublishDisplayDate ? (
            <div className="flex items-center gap-1">
              <span className="h-4 w-4">
                <MyImage src={calendarImage} alt="calender" />
              </span>
              <span>{convertDt24h(data.dPublishDate || data.dPublishDisplayDate)}</span>
            </div>
          ) : null}
          {data.nDuration ? (
            <div className="flex items-center gap-1">
              <ClockIcon />
              <span>{data.nDuration} Min Read</span>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}
export function MatchCardSmall({ data }: { data: NewsItem }) {
  return (
    <div className="w-full gap-3 text-white rounded-xl overflow-hidden flex relative">
      {data?.oSeo?.sSlug && data?.oSeo?.eStatus === 'a' ? (
        <CustomLink
          className="absolute inset-0 h-full w-full z-10 opacity-0"
          href={`/${data?.oSeo?.sSlug}`}
        >
          {data?._id}
        </CustomLink>
      ) : null}
      <div className="min-w-[132px] w-[132px] md:w-[140px] md:min-w-[140px] relative">
        <MyImage
          src={getImgURL(data?.oImg?.sUrl)}
          alt={data?.oImg?.sText}
          className="rounded-xl md:rounded-xl w-full object-cover"
          width={140}
          height={107}
        />
      </div>

      <div className="md:w-full flex flex-col justify-between">
        <div>
          <h2 className="text-base font-bold leading-snug mb-2 line-clamp-3 text-textOffWhite">
            {data?.sTitle}
          </h2>
        </div>

        <div className="flex items-center text-xs text-zinc-500 gap-4">
          {data.dPublishDate || data.dPublishDisplayDate ? (
            <div className="flex items-center gap-1">
              <span className="h-4 w-4">
                <MyImage src={calendarImage} alt="calender" />
              </span>
              <span>{convertDt24h(data.dPublishDate || data.dPublishDisplayDate)}</span>
            </div>
          ) : null}
          {data.nDuration ? (
            <div className="flex items-center gap-1">
              <ClockIcon />
              <span>{data.nDuration} Min Read</span>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}
